<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-5-cancelled-flights-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-5-cancelled-flights-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 1.13013698630137;"
    data-aspect-ratio="1.13"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-5-cancelled-flights-xs-img"
      class="g-post-5-cancelled-flights-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5-cancelled-flights-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.3492%;margin-top:-8.5px;left:68.9295%;width:56px;"
    >
      <p class="g-pstyle0">2,460</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.0199%;margin-top:-7.5px;left:0.6061%;width:135px;"
    >
      <p class="g-pstyle1">2,500 flights cancelled</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.2807%;margin-top:-8.5px;left:86.3429%;width:51px;"
    >
      <p class="g-pstyle0">2,187</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.1158%;margin-top:-7.5px;left:0.6061%;width:52px;"
    >
      <p class="g-pstyle1">2,000</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.1711%;margin-top:-8.5px;left:53.1695%;width:50px;"
    >
      <p class="g-pstyle0">1,519</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.2117%;margin-top:-7.5px;left:0.6061%;width:49px;"
    >
      <p class="g-pstyle1">1,500</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:49.3151%;right:53.0303%;width:18.7879%;"
    >
      <p class="g-pstyle2">Other airports</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.3076%;margin-top:-7.5px;left:0.6061%;width:50px;"
    >
      <p class="g-pstyle1">1,000</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:64.726%;right:53.0303%;width:16.0606%;"
    >
      <p class="g-pstyle2">Dubai</p>
      <p class="g-pstyle2">International</p>
      <p class="g-pstyle2">Airport</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.061%;margin-top:-7.5px;left:0.6061%;width:43px;"
    >
      <p class="g-pstyle1">500</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.1437%;margin-top:-8.5px;left:6.8129%;width:34px;"
    >
      <p class="g-pstyle0">15</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.1437%;margin-top:-8.5px;left:23.0975%;width:35px;"
    >
      <p class="g-pstyle0">10</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.1437%;margin-top:-8.5px;left:39.6193%;width:30px;"
    >
      <p class="g-pstyle0">8</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:2.7572%;width:59px;"
    >
      <p class="g-pstyle3">Feb. 25</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:19.0621%;width:59px;"
    >
      <p class="g-pstyle3">Feb. 26</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:35.3887%;width:58px;"
    >
      <p class="g-pstyle3">Feb. 27</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:51.3772%;width:59px;"
    >
      <p class="g-pstyle3">Feb. 28</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:67.7367%;width:59px;"
    >
      <p class="g-pstyle3">March 1</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3212%;margin-top:-7.5px;left:84.1653%;width:62px;"
    >
      <p class="g-pstyle3">March 2</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-5-cancelled-flights-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.37837837837838;"
    data-aspect-ratio="1.378"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-5-cancelled-flights-sm-img"
      class="g-post-5-cancelled-flights-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5-cancelled-flights-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.2381%;margin-top:-9.1px;left:58.107%;width:59px;"
    >
      <p class="g-pstyle0">2,460</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.9026%;margin-top:-8.5px;left:0.7843%;width:144px;"
    >
      <p class="g-pstyle1">2,500 flights cancelled</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.2381%;margin-top:-9.1px;left:72.7168%;width:53px;"
    >
      <p class="g-pstyle0">2,187</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.1188%;margin-top:-8.5px;left:0.7843%;width:55px;"
    >
      <p class="g-pstyle1">2,000</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.1999%;margin-top:-16.3px;left:85.9804%;width:63px;"
    >
      <p class="g-pstyle2">Other</p>
      <p class="g-pstyle2">airports</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.5895%;margin-top:-9.1px;left:44.8845%;width:53px;"
    >
      <p class="g-pstyle0">1,519</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.6053%;margin-top:-8.5px;left:0.7843%;width:52px;"
    >
      <p class="g-pstyle1">1,500</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.0918%;margin-top:-8.5px;left:0.7843%;width:52px;"
    >
      <p class="g-pstyle1">1,000</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs"
      style="top:65.9459%;left:85.9804%;width:13.5294%;"
    >
      <p class="g-pstyle3">Dubai</p>
      <p class="g-pstyle3">International</p>
      <p class="g-pstyle3">Airport</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.308%;margin-top:-8.5px;left:0.7843%;width:45px;"
    >
      <p class="g-pstyle1">500</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8597%;margin-top:-9.1px;left:5.9919%;width:35px;"
    >
      <p class="g-pstyle0">15</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8597%;margin-top:-9.1px;left:19.6545%;width:36px;"
    >
      <p class="g-pstyle0">10</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8597%;margin-top:-9.1px;left:33.516%;width:30px;"
    >
      <p class="g-pstyle0">8</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:3.0976%;width:62px;"
    >
      <p class="g-pstyle4">Feb. 25</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:16.825%;width:62px;"
    >
      <p class="g-pstyle4">Feb. 26</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:30.5676%;width:61px;"
    >
      <p class="g-pstyle4">Feb. 27</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:44.0728%;width:62px;"
    >
      <p class="g-pstyle4">Feb. 28</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:57.8385%;width:62px;"
    >
      <p class="g-pstyle4">March 1</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.281%;margin-top:-8.5px;left:71.6525%;width:65px;"
    >
      <p class="g-pstyle4">March 2</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-5-cancelled-flights-md"
    class="g-artboard"
    style="min-width: 660px;aspect-ratio: 1.83333333333333;"
    data-aspect-ratio="1.833"
    data-min-width="660"
  >
    <div
      id="g-post-5-cancelled-flights-md-img"
      class="g-post-5-cancelled-flights-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5-cancelled-flights-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.467%;margin-top:-9.1px;left:0.1515%;width:153px;"
    >
      <p class="g-pstyle0">2,500 flights cancelled</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.3003%;margin-top:-9.1px;left:60.6584%;width:59px;"
    >
      <p class="g-pstyle1">2,460</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.7447%;margin-top:-9.1px;left:75.2811%;width:53px;"
    >
      <p class="g-pstyle1">2,187</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.4114%;margin-top:-9.1px;left:0.1515%;width:57px;"
    >
      <p class="g-pstyle0">2,000</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.5781%;margin-top:-9.1px;left:87.803%;width:102px;"
    >
      <p class="g-pstyle2">Other airports</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.6892%;margin-top:-9.1px;left:46.8047%;width:53px;"
    >
      <p class="g-pstyle1">1,519</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.0781%;margin-top:-9.1px;left:0.1515%;width:54px;"
    >
      <p class="g-pstyle0">1,500</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.0225%;margin-top:-9.1px;left:0.1515%;width:54px;"
    >
      <p class="g-pstyle0">1,000</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs"
      style="top:65.2778%;left:87.803%;width:12.2727%;"
    >
      <p class="g-pstyle3">Dubai International Airport</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.6892%;margin-top:-9.1px;left:0.1515%;width:46px;"
    >
      <p class="g-pstyle0">500</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8003%;margin-top:-9.1px;left:5.5392%;width:35px;"
    >
      <p class="g-pstyle1">15</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8003%;margin-top:-9.1px;left:19.7329%;width:36px;"
    >
      <p class="g-pstyle1">10</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8003%;margin-top:-9.1px;left:34.3836%;width:30px;"
    >
      <p class="g-pstyle1">8</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:3.3027%;width:65px;"
    >
      <p class="g-pstyle4">Feb. 25</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:17.5175%;width:65px;"
    >
      <p class="g-pstyle4">Feb. 26</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:31.8371%;width:64px;"
    >
      <p class="g-pstyle4">Feb. 27</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:45.9502%;width:65px;"
    >
      <p class="g-pstyle4">Feb. 28</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:60.1499%;width:65px;"
    >
      <p class="g-pstyle4">March 1</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3003%;margin-top:-9.1px;left:74.1557%;width:68px;"
    >
      <p class="g-pstyle4">March 2</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-03 12:33 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-03 12:33 -->
<!-- ai file: post-5-cancelled-flights.ai -->
<style lang="scss">
  #g-post-5-cancelled-flights-box {
    container-type: inline-size;
    container-name: g-post-5-cancelled-flights-box;
  }
  #g-post-5-cancelled-flights-box,
  #g-post-5-cancelled-flights-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-5-cancelled-flights-box p {
    margin: 0;
  }
  #g-post-5-cancelled-flights-box .g-aiAbs {
    position: absolute;
  }
  #g-post-5-cancelled-flights-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-5-cancelled-flights-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-5-cancelled-flights-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-5-cancelled-flights-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-5-cancelled-flights-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-5-cancelled-flights-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-5-cancelled-flights-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-post-5-cancelled-flights-md {
        display: block !important;
      }
    }
  }
  #g-post-5-cancelled-flights-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5-cancelled-flights-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(51, 51, 51);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-5-cancelled-flights-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    color: rgb(123, 123, 123);
  }
  #g-post-5-cancelled-flights-xs .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    color: rgb(148, 148, 148);
  }
  #g-post-5-cancelled-flights-xs .g-pstyle2 {
    font-weight: 300;
    line-height: 12px;
    font-size: 10px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-5-cancelled-flights-xs .g-pstyle3 {
    font-weight: 300;
    height: 14px;
  }
  #g-post-5-cancelled-flights-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5-cancelled-flights-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(51, 51, 51);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-5-cancelled-flights-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(123, 123, 123);
  }
  #g-post-5-cancelled-flights-sm .g-pstyle1 {
    font-weight: 300;
    height: 16px;
    color: rgb(148, 148, 148);
  }
  #g-post-5-cancelled-flights-sm .g-pstyle2 {
    font-weight: 300;
    height: 16px;
    color: rgb(102, 102, 102);
  }
  #g-post-5-cancelled-flights-sm .g-pstyle3 {
    font-weight: 300;
    color: rgb(102, 102, 102);
  }
  #g-post-5-cancelled-flights-sm .g-pstyle4 {
    font-weight: 300;
    height: 16px;
  }
  #g-post-5-cancelled-flights-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5-cancelled-flights-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(51, 51, 51);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-5-cancelled-flights-md .g-pstyle0 {
    font-weight: 300;
    height: 17px;
    color: rgb(148, 148, 148);
  }
  #g-post-5-cancelled-flights-md .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    color: rgb(123, 123, 123);
  }
  #g-post-5-cancelled-flights-md .g-pstyle2 {
    font-weight: 300;
    height: 17px;
    color: rgb(102, 102, 102);
  }
  #g-post-5-cancelled-flights-md .g-pstyle3 {
    font-weight: 300;
    color: rgb(102, 102, 102);
  }
  #g-post-5-cancelled-flights-md .g-pstyle4 {
    font-weight: 300;
    height: 17px;
  }

  /* Custom CSS */
</style>
